/**
 * Payment Service
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional } from '@angular/core';
import {
  HttpClient,
  HttpHeaders,
  HttpParams,
  HttpResponse,
  HttpEvent,
  HttpParameterCodec,
  HttpContext,
} from '@angular/common/http';
import { CustomHttpParameterCodec } from '../encoder';
import { Observable } from 'rxjs';

// @ts-ignore
import { ErrorResponse } from '../model/errorResponse';
// @ts-ignore
import { PageInfoPaymentSearchResultDTO } from '../model/pageInfoPaymentSearchResultDTO';
// @ts-ignore
import { PaymentCreateRequestDTO } from '../model/paymentCreateRequestDTO';
// @ts-ignore
import { PaymentCreateResponseDTO } from '../model/paymentCreateResponseDTO';
// @ts-ignore
import { PaymentSearchParamsDTO } from '../model/paymentSearchParamsDTO';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS } from '../variables';
import { Configuration } from '../configuration';
import { BaseService } from '../api.base.service';

@Injectable({
  providedIn: 'root',
})
export class PaymentControllerService extends BaseService {
  constructor(
    protected httpClient: HttpClient,
    @Optional() @Inject(BASE_PATH) basePath: string | string[],
    @Optional() configuration?: Configuration
  ) {
    super(basePath, configuration);
  }

  /**
   * @param paymentCreateRequestDTO
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public create(
    paymentCreateRequestDTO: PaymentCreateRequestDTO,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: '*/*';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<PaymentCreateResponseDTO>;
  public create(
    paymentCreateRequestDTO: PaymentCreateRequestDTO,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: '*/*';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<PaymentCreateResponseDTO>>;
  public create(
    paymentCreateRequestDTO: PaymentCreateRequestDTO,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: '*/*';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<PaymentCreateResponseDTO>>;
  public create(
    paymentCreateRequestDTO: PaymentCreateRequestDTO,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: '*/*';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    if (
      paymentCreateRequestDTO === null ||
      paymentCreateRequestDTO === undefined
    ) {
      throw new Error(
        'Required parameter paymentCreateRequestDTO was null or undefined when calling create.'
      );
    }

    let localVarHeaders = this.defaultHeaders;

    // authentication (BearerAuthentication) required
    localVarHeaders = this.configuration.addCredentialToHeaders(
      'BearerAuthentication',
      'Authorization',
      localVarHeaders,
      'Bearer '
    );

    const localVarHttpHeaderAcceptSelected: string | undefined =
      options?.httpHeaderAccept ??
      this.configuration.selectHeaderAccept(['*/*']);
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set(
        'Accept',
        localVarHttpHeaderAcceptSelected
      );
    }

    const localVarHttpContext: HttpContext =
      options?.context ?? new HttpContext();

    const localVarTransferCache: boolean = options?.transferCache ?? true;

    // to determine the Content-Type header
    const consumes: string[] = ['application/json'];
    const httpContentTypeSelected: string | undefined =
      this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set(
        'Content-Type',
        httpContentTypeSelected
      );
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (
        this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)
      ) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/v1/payments/create`;
    const { basePath, withCredentials } = this.configuration;
    return this.httpClient.request<PaymentCreateResponseDTO>(
      'post',
      `${basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        body: paymentCreateRequestDTO,
        responseType: <any>responseType_,
        ...(withCredentials ? { withCredentials } : {}),
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress,
      }
    );
  }

  /**
   * @param paymentId
   * @param tenantId
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getPayment(
    paymentId: number,
    tenantId?: number,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: '*/*';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<PaymentCreateResponseDTO>;
  public getPayment(
    paymentId: number,
    tenantId?: number,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: '*/*';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<PaymentCreateResponseDTO>>;
  public getPayment(
    paymentId: number,
    tenantId?: number,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: '*/*';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<PaymentCreateResponseDTO>>;
  public getPayment(
    paymentId: number,
    tenantId?: number,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: '*/*';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    if (paymentId === null || paymentId === undefined) {
      throw new Error(
        'Required parameter paymentId was null or undefined when calling getPayment.'
      );
    }

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      <any>tenantId,
      'tenantId'
    );

    let localVarHeaders = this.defaultHeaders;

    // authentication (BearerAuthentication) required
    localVarHeaders = this.configuration.addCredentialToHeaders(
      'BearerAuthentication',
      'Authorization',
      localVarHeaders,
      'Bearer '
    );

    const localVarHttpHeaderAcceptSelected: string | undefined =
      options?.httpHeaderAccept ??
      this.configuration.selectHeaderAccept(['*/*']);
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set(
        'Accept',
        localVarHttpHeaderAcceptSelected
      );
    }

    const localVarHttpContext: HttpContext =
      options?.context ?? new HttpContext();

    const localVarTransferCache: boolean = options?.transferCache ?? true;

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (
        this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)
      ) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/v1/payments/${this.configuration.encodeParam({
      name: 'paymentId',
      value: paymentId,
      in: 'path',
      style: 'simple',
      explode: false,
      dataType: 'number',
      dataFormat: 'int64',
    })}`;
    const { basePath, withCredentials } = this.configuration;
    return this.httpClient.request<PaymentCreateResponseDTO>(
      'get',
      `${basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        params: localVarQueryParameters,
        responseType: <any>responseType_,
        ...(withCredentials ? { withCredentials } : {}),
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress,
      }
    );
  }

  /**
   * @param paymentSearchParamsDTO
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public searchPayments(
    paymentSearchParamsDTO: PaymentSearchParamsDTO,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: '*/*';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<PageInfoPaymentSearchResultDTO>;
  public searchPayments(
    paymentSearchParamsDTO: PaymentSearchParamsDTO,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: '*/*';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<PageInfoPaymentSearchResultDTO>>;
  public searchPayments(
    paymentSearchParamsDTO: PaymentSearchParamsDTO,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: '*/*';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<PageInfoPaymentSearchResultDTO>>;
  public searchPayments(
    paymentSearchParamsDTO: PaymentSearchParamsDTO,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: '*/*';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    if (
      paymentSearchParamsDTO === null ||
      paymentSearchParamsDTO === undefined
    ) {
      throw new Error(
        'Required parameter paymentSearchParamsDTO was null or undefined when calling searchPayments.'
      );
    }

    let localVarHeaders = this.defaultHeaders;

    // authentication (BearerAuthentication) required
    localVarHeaders = this.configuration.addCredentialToHeaders(
      'BearerAuthentication',
      'Authorization',
      localVarHeaders,
      'Bearer '
    );

    const localVarHttpHeaderAcceptSelected: string | undefined =
      options?.httpHeaderAccept ??
      this.configuration.selectHeaderAccept(['*/*']);
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set(
        'Accept',
        localVarHttpHeaderAcceptSelected
      );
    }

    const localVarHttpContext: HttpContext =
      options?.context ?? new HttpContext();

    const localVarTransferCache: boolean = options?.transferCache ?? true;

    // to determine the Content-Type header
    const consumes: string[] = ['application/json'];
    const httpContentTypeSelected: string | undefined =
      this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set(
        'Content-Type',
        httpContentTypeSelected
      );
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (
        this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)
      ) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/v1/payments/search`;
    const { basePath, withCredentials } = this.configuration;
    return this.httpClient.request<PageInfoPaymentSearchResultDTO>(
      'post',
      `${basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        body: paymentSearchParamsDTO,
        responseType: <any>responseType_,
        ...(withCredentials ? { withCredentials } : {}),
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress,
      }
    );
  }
}
